import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { ReplyPayload } from '../../schema';
import { CommentStatus } from '../../types';
import _ from 'lodash';

const FormReply = ({
  disabledFields,
}: {
  disabledFields?: { [key: string]: string };
}): JSX.Element => {
  const {
    register,
    formState: { errors },
  } = useFormContext<ReplyPayload>();
  return (
    <>
      <div className="space-y-4 mt-4">
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Tên người đánh giá
            <span className="text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            {...register('name')}
            readOnly={
              _.isUndefined(disabledFields) ||
              _.isUndefined(disabledFields['name'])
                ? false
                : true
            }
            className={clsx(
              errors.name
                ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              _.isUndefined(disabledFields) ||
                _.isUndefined(disabledFields['name'])
                ? null
                : 'bg-gray-100',
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
            )}
          />
          {errors.name ? (
            <p className="text-xs text-red-600">{errors.name.message}</p>
          ) : null}
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Email
            <span className="text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            {...register('email')}
            readOnly={
              _.isUndefined(disabledFields) ||
              _.isUndefined(disabledFields['email'])
                ? false
                : true
            }
            className={clsx(
              errors.email
                ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              _.isUndefined(disabledFields) ||
                _.isUndefined(disabledFields['email'])
                ? null
                : 'bg-gray-100',
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
            )}
          />
          {errors.email ? (
            <p className="text-xs text-red-600">{errors.email.message}</p>
          ) : null}
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Số điện thoại
          </label>
          <input
            type="text"
            {...register('phone')}
            readOnly={
              _.isUndefined(disabledFields) ||
              _.isUndefined(disabledFields['phone'])
                ? false
                : true
            }
            className={clsx(
              errors.phone
                ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              _.isUndefined(disabledFields) ||
                _.isUndefined(disabledFields['phone'])
                ? null
                : 'bg-gray-100',
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
            )}
          />
          {errors.phone ? (
            <p className="text-xs text-red-600">{errors.phone.message}</p>
          ) : null}
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Mô tả
            <span className="text-red-600 ml-1">*</span>
          </label>
          <textarea
            {...register('desc')}
            className={clsx(
              errors.desc
                ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
            )}
            rows={3}
          ></textarea>
          {errors.desc ? (
            <p className="text-xs text-red-600">{errors.desc.message}</p>
          ) : null}
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Trạng thái
          </label>
          <div className="flex justify-between">
            <div className="flex items-center justify-center space-x-1">
              <input
                id="status-active"
                type="radio"
                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                value={CommentStatus.active}
                {...register('status')}
              />
              <label
                htmlFor="status-active"
                className="block text-sm font-normal text-gray-700"
              >
                Hiển thị
              </label>
            </div>
            <div className="flex items-center justify-center space-x-1">
              <input
                id="status-pending"
                type="radio"
                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                value={CommentStatus.pending}
                {...register('status')}
              />
              <label
                htmlFor="status-pending"
                className="block text-sm font-normal text-gray-700"
              >
                Chờ duyệt
              </label>
            </div>
            <div className="flex items-center justify-center space-x-1">
              <input
                id="status-inactive"
                type="radio"
                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                value={CommentStatus.inactive}
                {...register('status')}
              />
              <label
                htmlFor="status-inactive"
                className="block text-sm font-normal text-gray-700"
              >
                Tạm ẩn
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default FormReply;
